import { NetidUtiqAdtechpass } from '@shared/constants/utiq';

export const getAdtechpassValueProxy = (
  fallbackAdtechpass: string | undefined,
) => {
  /* NetID Adtechpass should take precedence, if it exists */
  const netIdAdtechpass = localStorage.getItem(NetidUtiqAdtechpass);

  if (netIdAdtechpass) {
    return netIdAdtechpass;
  }

  return fallbackAdtechpass;
};
